import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FormGroup, FormControlLabel, Switch } from '@mui/material';
import React from 'react';
/**
 * Only renders for `HyperUser`
 */
export const DefaultVentureViewSwitch = ({ roleArbitrationInstance, useSpecializedViews, userFunctions }) => {
    const setUseSpecializedViews = (value) => {
        userFunctions.changeAppState({ useSpecializedViews: value });
    };
    return roleArbitrationInstance?.groupName === 'HyperUser' ? (_jsx(React.Fragment, { children: _jsx(FormGroup, { children: _jsx(FormControlLabel, { sx: { marginInline: 0 }, control: _jsx(Switch, { checked: useSpecializedViews, onChange: (_e, checked) => setUseSpecializedViews(checked), name: useSpecializedViews ? 'Venture' : 'Default', inputProps: { 'aria-label': 'secondary checkbox' } }), label: 'Venture views' }) }) })) : (_jsx(_Fragment, {}));
};
